/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface ISocketDisconnectMessage extends IMessage {
	id: string;
}

export default class SocketDisconnectMessage extends Message {
	public static readonly TYPE: string = '33';

	public static readonly READABLE_TYPE_NAME: string = 'disconnectSocket';

	public static readonly DESCRIPTOR_NAME: string = 'SocketDisconnectMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				type: 'string',
				id: 1
			}
		}
	};

	public constructor( public readonly id: string ) {
		super();
	}

	public toJSON(): ISocketDisconnectMessage {
		return {
			id: this.id
		};
	}

	public static fromJSON( data: ISocketDisconnectMessage ): SocketDisconnectMessage {
		return new SocketDisconnectMessage( data.id );
	}
}
